var image_upload_default = {
  "container": "VSY0q",
  "disabled": "BqkN1",
  "imageInput": "_7ELV0",
  "overlay": "_6afIK",
  "text": "UeZbN",
  "shown": "Acnwo",
  "hide": "_5xby6",
  "spinner": "m56hG",
  "spin": "oiuAG"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
